import { Helmet } from "react-helmet";

const SITE_URL = "https://www.vergado.io";
const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;

const normalizeCanonicalPath = (rawPath = "/") => {
  const cleanPath = rawPath.split(/[?#]/)[0].trim();
  const withLeadingSlash = cleanPath.startsWith("/")
    ? cleanPath
    : `/${cleanPath}`;
  const squashedSlashes = withLeadingSlash.replace(/\/{2,}/g, "/");

  if (squashedSlashes === "/") {
    return "/";
  }

  return squashedSlashes.toLowerCase().replace(/\/$/, "");
};

const Seo = ({
  title,
  description,
  path,
  keywords,
  ogImage = DEFAULT_OG_IMAGE,
  ogType = "website",
  noIndex = false,
  schema,
}) => {
  const canonical = `${SITE_URL}${normalizeCanonicalPath(path || "/")}`;
  const fullTitle = title.includes("Vergado") ? title : `${title} | Vergado`;
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];

  return (
    <Helmet>
      <html lang="en-IN" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta
        name="robots"
        content={
          noIndex
            ? "noindex,nofollow"
            : "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1"
        }
      />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content="Vergado" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:alt" content={fullTitle} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {schemas.map((s, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(s)}
        </script>
      ))}
    </Helmet>
  );
};

export default Seo;
